import { Component } from "react";
import FallBackUI from "../fallBackUI/FallBackUI";

export default class GlobalErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: "" };
  }

  static getDerivedStateFromError(error) {
    console.log("GET DERIVED STATE: ", error);
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.log("ERROR: ", error);
    console.log("ERROR INFO: ", errorInfo);
  }
  handleHideFallError() {
    this.setState({
      hasError: false,
      error: "",
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <>
          <FallBackUI
            error={this.state.error}
            handleHideFallError={this.handleHideFallError}
          />
        </>
      );
    }

    return this.props.children;
  }
}
